import { couponsMock } from '~/utils/mocks/couponsMock';

const CouponService = {
  getAllCoupons() {
    return couponsMock;
  },
};

export default CouponService;
